import { propEq } from 'ramda'
import getStorage from '../../Common/Services/Storage'
// import { columns as dapJobColumns } from '../../Data/Models/DataAnalyticsJob'
const storageService = getStorage()

export const invalidateShortcutsByFavorite = (shortcuts) => {
  if (
    Object.keys(shortcuts).length &&
    shortcuts[Object.keys(shortcuts)[0]].__favorite === undefined
  ) {
    return true
  }
  return false
}

/** example of invalidate function
export const invalidateDataAnalyticsChangelistTable = storageKey => {
  // just return 'REMOVE' string in order to force storage key deletion
  const data = storageService.get(storageKey)
  if (!dapJobColumns.find(propEq('id', data?.defaultSortField))) {
    data.defaultSortField = 'createdOn';
    storageService.save(storageKey, data)
  }
}
*/

// users now have multi segments
export const invalidateUsersListChangelistTable = (storageKey) => {
  // just return 'REMOVE' string in order to force storage key deletion
  const data = storageService.get(storageKey)
  if (
    data?.columns?.length &&
    data.columns.filter(propEq('id', 'segments')).length === 0
  ) {
    return 'REMOVE'
  }
}
